import { useSearchPageQuery } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/__internal__/useSearchPageQuery";
import { IBrandOffFaireQueryRewritingResponse } from "@faire/web-api--source/indigofair/data/IBrandOffFaireQueryRewritingResponse";

export const useSearchPageBrandsOffFaireQuery = ():
  | IBrandOffFaireQueryRewritingResponse
  | undefined => {
  return useSearchPageQuery().data?.brand_off_faire_query_rewriting_response;
};
